<script>
export default {
  props: ["berita", "textColor", "meta"],
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    this.content = this.berita.body
      .replace("<p>", "")
      .replace("</p>", "")
      .replace(
        '<span style="background-color:rgb(255,255,255);color:rgb(0,0,0);">',
        ""
      )
      .replace("</span>", "");
  },
};
</script>
<template>
  <div
    class="blog-post-slider__single-slide blog-post-slider__single-slide--grid-view"
  >
    <div class="blog-post-slider__image section-space--bottom--20">
      <router-link :to="`berita-detail${meta.preview}id=${berita.url}`">
        <img
          :src="berita.image"
          class="img-fluid img-berita"
          alt="blog-image"
        />
      </router-link>
    </div>
    <div class="blog-post-slider__content">
      <h3 class="post-title">
        <router-link
          data-toggle="tooltip"
          data-placement="top"
          :title="berita.title"
          :to="`berita-detail${meta.preview}id=${berita.url}`"
          >{{ berita.title.slice(0, 18) + `...` }}</router-link
        >
      </h3>
      <p class="post-date">
        {{ berita.author != null ? berita.autho : "Admin" }},{{
          berita.published_at
        }}
      </p>
      <p class="post-excerpt">
        {{
          berita.body
            .replace(/<\/?[^>]+(>|$)/g, "")
            .substring(0, 100)
            .slice(0, 100) + `...`
        }}
      </p>
      <div class="text-right">
        <router-link
          :to="`berita-detail${meta.preview}id=${berita.url}`"
          class="font-weight-bold"
          :class="textColor"
          >Selengkapnya</router-link
        >
      </div>
    </div>
  </div>
</template>
